var exports = {
  "O3": "x31de4314--030599--underground",
  "VV": "x31de4314--030599--undergroundIcon",
  "x6": "x31de4314--030599--travelTimeIcon",
};

module.exports = exports;
